export function fmt(value: string | number | null | undefined, decimals = 2): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'string' ? Number(value) : value;
  if (Number.isNaN(n)) return String(value);
  return n.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function short(value: string | null | undefined, n = 6): string {
  if (!value) return '—';
  if (value.length <= n * 2 + 3) return value;
  return `${value.slice(0, n)}…${value.slice(-n)}`;
}
